<script>
import { BFormSpinbutton } from "bootstrap-vue";

export default {
  extends: BFormSpinbutton
};
</script>